import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useIntl } from "@grandvisionhq/state";
import { aabFAQClickEvent } from "../../../../../data-layer/v3/data-layer/actions.js";
import useDataLayerInput from "../../../../../hooks/v3/hooks/use-data-layer-input.js";
import { usePageData } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/PageDataContext.js";
import AppointmentFaq from "./AppointmentFaq.js";
/* empty css                    */
const AppointmentFaqContainer = () => {
  const [isFaqOpen, setIsFaqOpen] = React.useState(false);
  const { getLabel } = useIntl();
  const { appointmentFaq } = usePageData();
  const dataLayerInput = useDataLayerInput();
  const onClickHandler = () => {
    DataLayer.pushEvent(aabFAQClickEvent(dataLayerInput));
    setIsFaqOpen(true);
  };
  const onCloseModal = () => setIsFaqOpen(false);
  if (!appointmentFaq?.faqItems || appointmentFaq?.faqItems?.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "appointment-faq__container" }, /* @__PURE__ */ React.createElement("button", { type: "button", onClick: onClickHandler, className: "appointment-faq__button" }, /* @__PURE__ */ React.createElement("span", null, getLabel("appointments.component.appointmentTypes.faq"))), /* @__PURE__ */ React.createElement(AppointmentFaq, { ...appointmentFaq, isOpen: isFaqOpen, onModalClose: onCloseModal }));
};
export {
  AppointmentFaqContainer as default
};
//# sourceMappingURL=AppointmentFaqContainer.js.map
